import { useEffect, useState } from "react";
import { CONNECTION_LOST_EVENT, CONNECTION_RESTORED_EVENT } from "../lib/api";

// Issue #759: a single place both the shared fetch layer (lib/api.ts) and UserContext's periodic
// session recheck report into, so any surface that needs "is the app actually reachable right
// now" (today: ConnectionStatusBanner) reads the same signal instead of re-deriving it - this is
// also the hook a future push-channel fallback (#767) should reuse rather than inventing its own.
function useConnectionStatus() {
    const [isConnected, setIsConnected] = useState(true);

    useEffect(() => {
        const onLost = () => setIsConnected(false);
        const onRestored = () => setIsConnected(true);
        window.addEventListener(CONNECTION_LOST_EVENT, onLost);
        window.addEventListener(CONNECTION_RESTORED_EVENT, onRestored);
        return () => {
            window.removeEventListener(CONNECTION_LOST_EVENT, onLost);
            window.removeEventListener(CONNECTION_RESTORED_EVENT, onRestored);
        }
    }, []);

    return isConnected;
}

export default useConnectionStatus;
